import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'
import * as React from 'react'

function makeQueryClient() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60 * 1000,
            },
        },
    })
}

let browserQueryClient: QueryClient | undefined = undefined

function getQueryClient() {
    if (!browserQueryClient) {
        browserQueryClient = makeQueryClient()
        if (typeof window !== 'undefined') {
            (window as any).queryClient = browserQueryClient
        }
    }
    return browserQueryClient
}

export default function QueryProvider(props: { children: React.ReactNode }) {
    const queryClient = getQueryClient()

    return (
        <QueryClientProvider client={queryClient}>
            {props.children}
        </QueryClientProvider>
    )
}